import { useState, useEffect } from 'react';

interface NavbarProps {
  onScrollTo: (id: string) => void;
}

export default function Navbar({ onScrollTo }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black shadow-lg' : 'bg-black'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
        <img
          alt="Four Models"
          className="h-8 sm:h-10 md:h-12 object-contain"
          src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/3c6853a00769ef0b898cf7c7be2b9fe6.png"
        />
        <button
          onClick={() => onScrollTo('inscricao')}
          className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 rounded-full font-bold text-xs sm:text-sm hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          INSCREVA-SE
        </button>
      </div>
    </nav>
  );
}
